module.exports = __webpack_public_path__ + "static/media/tela2.d332c5d9.png";